<template>
    <counsel-card-row label="기간" :cols="12" :md="4"> {{ startsAt }} > {{ endsAt }} </counsel-card-row>
</template>

<script>
import counselCardRow from "./counsel-card-row.vue";
export default {
    components: { counselCardRow },
    props: ["request"],
    computed: {
        startsAt() {
            return this.request.startsAt.toDate();
        },
        endsAt() {
            return this.request.endsAt.toDate();
        },
    },
};
</script>

<style></style>
